import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import useSWR from "swr";
import { orderUrls } from "../../../Api/Auth/ApiUrls";
import QueryString from "qs";
import useTable from "../../../hooks/useTable";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import { Loader } from "../../../Components/Common/Loader";
import NoData from "../../../Components/Common/NoData";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import NotFound from "../../Notfound";
import DashboardRow from "../../Admin/Dashboard/Components/DashboardTableRow";

const tableColumnData = [
  { id: "_id", label: "Order ID" },
  { id: "item", label: "Item" },
  { id: "userName", label: "Ordered By" },
  { id: "amount", label: "Amount" },
  { id: "transactionId", label: "Transaction ID" },
  { id: "createdAt", label: "Created" },
];

const StudentDashboard = () => {
  const location = useLocation();
  const { userData } = useAuth();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate } = useSWR(
    orderUrls.userList(userData?._id, apiQueryString)
  );

  if (userData?.roleId === 6) {
    return <NotFound />;
  }

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <span className="px-4"> Hello {userData?.name}!</span>
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <DashboardRow key={row._id} mutate={mutate} row={row} student />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default StudentDashboard;
